import DEMO_MODE_ACTION_TYPES from '../../actionTypes/shared/demoModeActionTypes';
import {
    DEFAULT_DEMO_TYPE,
    DEMO_TYPES,
    DEFAULT_DEMO_CLASS,
    STEP,
} from '../../../constants/reading/DemoModeConstants';

export const initialState = {
    isGuidedTourOn: false,
    isDemoModeOn: (localStorage.getItem('inDemo') || false) === 'true',
    demoData: {},
    isDemoDataLoaded: false,
    demoType: DEFAULT_DEMO_TYPE,
    demoClass: localStorage.getItem('demoClass') || DEFAULT_DEMO_CLASS,
    hasTourStarted: false,
    activeTourStep: localStorage.getItem('activeTourStep') || STEP[0],
    visitedTourSteps: JSON.parse(localStorage.getItem('visitedTourSteps')) || [STEP[0]],
    errors: {},
    demoStaff: { firstName: 'Demomode', lastName: 'Teacher' },
};

export const reducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case DEMO_MODE_ACTION_TYPES.LAUNCH_DEMO: {
            return {
                ...state,
                isDemoModeOn: true,
            };
        }
        case DEMO_MODE_ACTION_TYPES.CLOSE_DEMO: {
            return {
                ...state,
                isDemoModeOn: false,
            };
        }
        case DEMO_MODE_ACTION_TYPES.SET_DEMO_TYPE:
            return {
                ...state,
                demoType: action.payload,
                isGuidedTourOn: action.payload === DEMO_TYPES.GUIDED_TOUR,
            };
        case DEMO_MODE_ACTION_TYPES.SET_DEMO_CLASS:
            return {
                ...state,
                demoClass: action.payload,
            };
        case DEMO_MODE_ACTION_TYPES.SET_ACTIVE_TOUR_STEP_ID:
            return {
                ...state,
                activeTourStep: action.activeTourStep,
                visitedTourSteps: action.visitedTourStepsPayload,
            };
        case DEMO_MODE_ACTION_TYPES.RESET_TOUR:
            localStorage.setItem('visitedTourSteps', JSON.stringify([STEP[0]]));
            localStorage.setItem('activeTourStep', STEP[0]);
            return {
                ...state,
                activeTourStep: STEP[0],
                visitedTourSteps: [STEP[0]],
            };
        case DEMO_MODE_ACTION_TYPES.SET_HAS_DEMO_TYPE_TRANSITION_ENDED:
            return {
                ...state,
                hasTourStarted: state.isGuidedTourOn && action.payload,
            };
        case DEMO_MODE_ACTION_TYPES.LOAD_DEMO_DATA:
            return {
                ...state,
                demoData: action.payload,
                isDemoDataLoaded: true,
            };
        case DEMO_MODE_ACTION_TYPES.LOAD_DEMO_ERROR:
            return {
                ...state,
                errors: { DEMO_DATA_ERROR: action.payload },
            };
        default:
            return state;
    }
};

const getIsDemoModeOn = state => {
    return state.isDemoModeOn;
};
const getIsGuidedTourOn = state => {
    return state.isGuidedTourOn;
};

const getDemoType = state => {
    return state.demoType;
};
const getDemoClass = state => {
    return state.demoClass;
};
const getVisitedTourSteps = state => {
    return state.visitedTourSteps;
};
const getActiveStep = state => {
    return state.activeTourStep;
};
const getHasTourStarted = state => {
    return state.hasTourStarted;
};
const getIsDemoDataLoaded = state => {
    return state.isDemoDataLoaded;
};
const getDemoResultsData = state => {
    return state.demoResultsData;
};
const getDemoStaff = state => {
    return state.demoStaff;
};

export const selectors = {
    getIsDemoModeOn,
    getIsGuidedTourOn,
    getDemoType,
    getActiveStep,
    getDemoClass,
    getVisitedTourSteps,
    getHasTourStarted,
    getIsDemoDataLoaded,
    getDemoResultsData,
    getDemoStaff,
};
